<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Permissões' btnLink='$back' btnTxt='Voltar'
      :action="`Permissões de ${user.name}`"/>

      <div>

        <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

        <div class="row">

          <div class="col-lg-3">
            <div class="wrapper wrapper-content project-manager">
              <img src="/static/img/logo-ssparisi.png" class="img-responsive">

              <div class="products-container">
                <h4>Escolha um produto</h4>

                <p class="small font-bold">
                  <span><i class="fa fa-circle text-success"></i> Produtos disponíveis </span>
                </p>

                <div v-if="products.length == 0">
                  <p>Nenhum produto disponível</p>
                </div>

                <div v-if="products.length > 0">
                  <div class="list-group">
                    <a v-for="product in products" :key="product.public_key"
                      @click.prevent="selectProduct(product)"
                      :class="{active: product === selectedProduct}"
                      class="list-group-item animated fadeIn"> {{ product.description }}
                    </a>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <div class="col-lg-6">

            <div v-if="!selectedProduct" class="non-selected">
              <h2 > Nenhum produto selecionado </h2>
            </div>

            <div v-if="selectedProduct" class="animated fadeInLeft">
              <div class="ibox">

                <div class="ibox-title">
                  <h5>Escolha uma ou mais empresas</h5>
                </div>

                <div class="ibox-content">

                  <div class="row">
                    <div class="col-sm-12">
                      <button class="btn btn-w-m btn-white pull-right all-btn" @click.prevent="checkAllCompanies()"> Marcar todos </button>
                    </div>
                  </div>

                  <list-filter v-on:filter="onFilter" :attributes="searchableFields"></list-filter>

                  <div class="list-group">
                    <a v-for="(company, index) in companies" :key="company.public_key"
                      @click.prevent="selectCompany(index)" :class="{ active: selectedCompanies.indexOf(company) != -1 }"
                      class="list-group-item animated fadeIn">
                      <i class="fa fa-star" v-if="company === getCompany()"></i>
                      {{ company.fantasy || company.name }}
                    </a>
                  </div>

                  <pagination-links v-on:paginate="onPaginate" :more="more" :page="query.page"></pagination-links>

                </div>

              </div>
            </div>

            <div class="row">
              <div v-show="selectedCompanies.length > 0" class="col-lg-12 animated fadeInLeft">
                <div class="ibox">

                  <div class="ibox-title">
                    <h5>Marque as permissões desejadas</h5>
                  </div>

                  <div v-show="permissions.length > 0" class="ibox-content">

                    <div class="row">
                      <div class="col-sm-12">
                        <button class="btn btn-w-m btn-white pull-right all-btn" @click.prevent="checkAll()"> Marcar todas </button>
                      </div>
                    </div>

                    <div class="list-group">
                      <a v-for="perm in permissions" :key="perm.public_key" :class="[`level-${ perm.level }`, {checked: perm.allow_access}]" class="list-group-item no-pointer animated fadeIn">
                        {{ perm.description }}
                        <input @change="modifyChildren(perm)" type="checkbox" class="i-checks pull-right" v-model="perm.allow_access"/>
                      </a>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <p v-if="noPermissionSelected && selectedProduct" class="alert alert-danger left animated fadeInDown"><strong>Atenção:</strong> desmarcar todas as permissões removerá o acesso de <strong>{{user.name}}</strong> no <strong>{{selectedProduct.description}}</strong> nas empresas selecionadas.</p>

                        <button v-if="!noPermissionSelected" class="btn btn-w-m btn-success pull-right" @click.prevent="savePermissions()">
                          <i class="fa fa-save"></i> Salvar </button>
                        <button v-show="noPermissionSelected" type="button" class="btn btn-w-m btn-danger pull-right" data-dismiss="modal" @click.prevent="removePermissions()">Remover acesso</button>
                      </div>
                    </div>

                  </div>

                  <div v-show="permissions.length === 0" class="ibox-content center">
                    Nenhuma permissão para esse produto.
                  </div>

                </div>
              </div>
            </div>

          </div>

          <div class="col-lg-3">

            <div class="wrapper wrapper-content project-manager">
              <h4>Acesso</h4>

              <p class="small">
                Empresa(s) que o Usuário <strong>{{ user.name }}</strong> já possui algum tipo de acesso ou permissão
              </p>
              <p class="small font-bold">
                <span><i class="fa fa-circle text-success"></i> Empresas: </span>
              </p>

              <ul class="tag-list" style="padding: 0">
                <li v-for="cmp in user.companies" :key="cmp.public_key">
                  <a style="cursor: default"><i class="fa fa-building"></i> {{ cmp.fantasy || cmp.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

  import NavMenu from './layout/NavMenu'
  import SideMenu from './layout/SideMenu'
  import BreadCrumps from './layout/BreadCrumps'
  import PageFooter from './layout/PageFooter'
  import Spinner from './layout/Spinner'
  import PaginationLinks from './PaginationLinks'
  import ListFilter from './ListFilter'

  import { httpService } from '../providers/http-service'
  import { toast } from '../mixins/toast'
  import { errorMessage } from '../mixins/error-message'
  import { permissionManager } from '../mixins/permission-manager'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [ toast, errorMessage, permissionManager ],
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter, Spinner, PaginationLinks, ListFilter },
    data () {
      return {
        //--- Permissões ---//
        user: this.$route.query,
        permissions: [],
        children: {},

        //--- Listagem de produtos ---//
        products: [],
        selectedProduct: null,
        prd: null,

        //--- Listagem de clientes ---//
        selectedCompanies: [],
        more: false,
        showSpinner: false,
        companies: [this.getCompany()],
        query: { filter: '', page: 0, limit: 10 },
        searchableFields: [
          { value: 'name', label: 'Razão Social' },
          { value: 'document', label: 'CNPJ' },
          { value: 'fantasy', label: 'Nome Fantasia' },
        ]
      }
    },
    methods: {
      ...mapGetters(['getLoggedUserId', 'getCompany']),

      //--- Permissões ---//
      getPermissions() {
        this.showSpinner = true
        this.children = {}
        return httpService.getUserPermissions(this.selectedCompanies[0].public_key, this.selectedProduct.public_key, this.user.public_key).then((res) => {
          this.permissions = res.data.map((perm) => {
            perm.level = this.getLevel(perm)
            return perm
          })
          this.orderPermissions()
          this.showSpinner = false
        }).catch(err => this.showErrorMessage({ err: err }))
      },

      savePermissions() {
        const permissions = this.permissions.filter(perm => !perm.allow_access).map(perm => perm.public_key)
        this.showSpinner = true
        Promise.all(this.selectedCompanies.map(cmp => httpService.saveUserPermissions(cmp.public_key, this.selectedProduct.public_key, this.user.public_key, permissions)))
        .then(() => {
          this.showSpinner = false
          this.show_toast('success', 'OK', 'Permissões atualizadas com sucesso!')
        }).catch(err => this.showErrorMessage({ err: err }))
      },

      removePermissions() {
        Promise.all(this.selectedCompanies.map(cmp => httpService.removeUserAccess(cmp.public_key, this.selectedProduct.public_key, this.user.public_key)))
        .then(() => {
          this.showSpinner = false
          this.show_toast('success', 'OK', 'Permissões removidas com sucesso!')
        }).catch(err => this.showErrorMessage({ err: err }))
      },

      //--- Produtos ---//
      selectProduct(product) {
        this.selectedProduct = null
        this.prd = product.public_key
        this.permissions = []
        this.resetCompanies()
        this.query = { filter: '', page: 0, limit: 10, status: 1 }
        this.showSpinner = true
        return this.getCompaniesByProduct(product.public_key).then((res) => {
          this.selectedProduct = product
          this.verifySelectedCompanies()
          this.showSpinner = false
        })
      },

      getProductsList() {
        this.showSpinner = true
        return httpService.getProductsList().then((res) => {
          this.products = res.data
          this.showSpinner = false
        })
      },

      accessPage(company) {
        this.$router.push({ path: '/company/access', query: company })
      },

      //--- Listagem de clientes ---//
      resetCompanies() {
        this.companies = this.getCompany().public_key === '944b1b76411de44f9c81aecd23a8499f' ? [] : [this.getCompany()]
      },

      selectCompany(index) {
        const indexOnSelected = this.selectedCompanies.indexOf(this.companies[index])
        if (indexOnSelected != -1) {
          this.selectedCompanies.splice(indexOnSelected, 1)
        } else {
          this.selectedCompanies.push(this.companies[index])
        }
        if (this.selectedCompanies.length > 0 && this.permissions.length === 0) {
          this.getPermissions()
        }
      },

      getCompaniesByProduct(productId) {
        this.selectedCompanies = []
        this.showSpinner = true
        return httpService.getCustomersByProduct(productId, this.query).then(res => {
          this.companies.push(...res.data)
          this.showSpinner = false
          this.more = res.data.length === this.query.limit
        }).catch((err) => { this.showErrorMessage({ err: err }) })
      },


      verifySelectedCompanies() {
        this.companies.forEach((cmp, index) => {
          // this.user.companies.forEach(userCmp => {
          //   if(userCmp.public_key === cmp.public_key) {
          //     this.selectCompany(index)
          //   }
          // })
        })
      },

      onFilter(filter) {
        this.resetCompanies()
        this.query.page = 0
        this.query.filter = filter
        this.getCompaniesByProduct(this.selectedProduct.public_key)
      },

      onPaginate(pagination) {
        this.query.page = pagination.page
        this.query.limit = pagination.limit
        this.getCompaniesByProduct(this.selectedProduct.public_key)
      },

      checkAllCompanies() {
        this.selectedCompanies = [... this.companies]
        if(this.permissions.length === 0) this.getPermissions()
      },
    },
    mounted() {
      this.resetCompanies()
      this.getProductsList()
    }
  }
</script>

<style scoped>

  .img-responsive { max-width: 200px; }

  .no-pointer { cursor: default; }
  .level-1 { margin-left: 0px;  }
  .level-2 { margin-left: 20px; }
  .level-3 { margin-left: 40px; }
  .level-4 { margin-left: 60px; }
  .level-5 { margin-left: 80px; }

  input[type="checkbox"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }

  .products-container {
    padding-top: 10px;
    text-align: center;
  }

  .list-group {
    max-height: 550px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .col-lg-9 { padding-left: 2px; padding-right: 4px; }

  .list-group a { background-color: #fff; }

  .all-btn { margin-bottom: 10px; }

  .non-selected {
    padding-top: 40px;
    margin-right: 120px;
    text-align: center;
    font-style: italic;
    font-weight: bolder;
  }

  .active { background-color: #1c84c6!important; border-color: #1c84c6!important; }
</style>



// WEBPACK FOOTER //
// src/components/UserPermissionPage.vue